module.exports = __webpack_public_path__ + "img/CtrlRoom_vol_4.080cf558.png";